<ng-container *ngIf="filterTemplate else defaultFilter">
    <ng-container [ngTemplateOutlet]="filterTemplate" ></ng-container>
</ng-container>

<ng-template #defaultFilter>
    <div class="d-flex justify-content-between flex-wrap">
        <div class="pt-4 me-auto">
            <button type="button" (click)="showActive()" class="text-uppercase fw-bold px-3" [ngClass]="{'btn-gold':searchService.filters.auctionStatus==1, 'btn-white':searchService.filters.auctionStatus!=1}">
                {{"IDS_ACTIVE_AUCTION" | translate}}
            </button>
            <button type="button" (click)="showClosed()" class="text-uppercase fw-bold px-3 ms-1" [ngClass]="{'btn-gold':searchService.filters.auctionStatus==2, 'btn-white':searchService.filters.auctionStatus!=2}">
                {{"IDS_CLOSED_AUCTION" | translate}}
            </button>
            <button type="button" (click)="showAll()" class="text-uppercase fw-bold px-3 ms-1" [ngClass]="{'btn-gold':searchService.filters.auctionStatus==-1, 'btn-white':searchService.filters.auctionStatus!=-1}">
                {{"IDS_ALL_AUCTION" | translate}}
            </button>
        </div>
        <div ngbDropdown class="pt-4">
            <button class="filterDropdown text-start d-flex fw-bold" type="button" ngbDropdownToggle>
                {{getOrderButtonTranslation() | translate}}{{currentOrder | translate}}
                <fa-icon class="ms-3" [icon]="faSort" size="sm"></fa-icon>
            </button>
            <div ngbDropdownMenu>
                <button type="button" ngbDropdownItem class="filterDropdownLink" (click)="orderBy(0)">
                    {{"IDS_EVIDENCE" | translate}}
                </button>
                <button type="button" ngbDropdownItem class="filterDropdownLink" (click)="orderBy(1)">
                    {{"IDS_HIGHER_PRICE" | translate}}
                </button>
                <button type="button" ngbDropdownItem class="filterDropdownLink" (click)="orderBy(2)">
                    {{"IDS_LOWER_PRICE" | translate}}
                </button>
                <button type="button" ngbDropdownItem class="filterDropdownLink" (click)="orderBy(3)">
                    {{"IDS_MOST_RECENT_CLOSING_DATE" | translate}}
                </button>
                <button type="button" ngbDropdownItem class="filterDropdownLink" (click)="orderBy(4)">
                    {{"IDS_EARLIEST_CLOSING_DATE" | translate}}
                </button>
            </div>
        </div>
    </div>
</ng-template>

<hr>

<ng-container [ngTemplateOutlet]="!showMarketplaceFirst ? memorabidAuctionsTemplate : marketplaceAuctionsTemplate"></ng-container>
<ng-container [ngTemplateOutlet]="!showMarketplaceFirst ? marketplaceAuctionsTemplate : memorabidAuctionsTemplate"></ng-container>
<div *ngIf="memorabidAuctionsCount == 0 && marketplaceAuctions.length == 0">
    <label class="fw-bold py-4">{{ "IDS_NO_RESULTS" | translate}}</label>
</div>

<ng-template #memorabidAuctionsTemplate ngSkipHydration>
    <div *ngIf="memorabidAuctionsCount > 0">
        <app-bid-box-header *ngIf="showHeader" [isGoldAuction]="true"></app-bid-box-header>
        <div *ngIf="!showHeader" class="mt-4"></div>
        <app-bid-box
            [memorabidAuctions]="memorabidAuctions"
            [startingAuctionNumber]="startingAuctionNumber"
            [memorabidAuctionsCount]="memorabidAuctionsCount"
            [showRemainingAuctionNumber]="true"
            [isLarge]="isBidBoxLarge"
            [isSearchPage]="true"
            (showMoreRequested)="showMoreClick()"
            showMoreText="IDS_MEMORABID_SEE_MORE">
        </app-bid-box>
    </div>
</ng-template>
<ng-template #marketplaceAuctionsTemplate ngSkipHydration>
    <div class="auctions-marketplace" *ngIf="marketplaceAuctions.length > 0">
        <app-bid-box-header *ngIf="showHeader" [isGoldAuction]="false"></app-bid-box-header>
        <div *ngIf="!showHeader" class="mt-4"></div>
        <app-bid-box
            [marketplaceAuctions]="marketplaceAuctions"
            [startingAuctionNumber]="startingAuctionNumber"
            [showRemainingAuctionNumber]="true"
            [isLarge]="isBidBoxLarge"
            [isSearchPage]="true"
            [marketplaceAuctionsCount]="marketplaceAuctionsCount"
            (showMoreRequested)="showMoreClick()"
            showMoreText="IDS_MARKETPLACE_SEE_MORE">
        </app-bid-box>
    </div>
</ng-template>
